export function isJobFeatured(job) {
  const today = new Date();
  return job.isFeaturedPromotion && job.dateFeaturedExpiring >= today;
}

export function isJobSponsored(job) {
  const today = new Date();
  return job.isSponsoredPromotion && job.dateSponsoredExpiring >= today;
}

export function isJobStandard(job) {
  return !isJobFeatured(job) && !isJobSponsored(job);
}
